import { Routes } from '@angular/router';
import { NotFoundPageComponent } from '@sb-tools/typescript/components/error-pages/not-found-page/not-found-page.component';
import { ConfigurationResolve } from '@shared/services/configuration.resolve';
import { CanActivateSettings } from '@shared/guards/can-activate-settings.guard';
import { AccessDeniedPageComponent } from '@sb-tools/typescript/components/error-pages/access-denied-page/access-denied-page.component';
import { UnauthorizedFaqErrorPageComponent } from '@sb-tools/typescript/components/error-pages/unauthorized-faq-error-page/unauthorized-faq-error-page.component';

export const APP_ROUTES: Routes = [
    { path: '404', component: NotFoundPageComponent },
    { path: '403', component: AccessDeniedPageComponent },
    { path: 'unauthorized-faq-error', component: UnauthorizedFaqErrorPageComponent },
    {
        path: ':communityName/admin',
        canActivate: [CanActivateSettings],
        resolve: {
            configuration: ConfigurationResolve,
        },
        loadChildren: () => import('./settings/settings-routes').then((m) => m.SETTINGS_ROUTES),
    },
    {
        path: ':communityName/:faqName/admin',
        canActivate: [CanActivateSettings],
        resolve: {
            configuration: ConfigurationResolve,
        },
        loadChildren: () => import('./settings/settings-routes').then((m) => m.SETTINGS_ROUTES),
    },
    {
        path: ':communityName',
        loadChildren: () => import('./faq/faq-routes').then((m) => m.FAQ_ROUTES),
    },
    {
        path: ':communityName/:faqOrLanguage',
        loadChildren: () => import('./faq/faq-routes').then((m) => m.FAQ_ROUTES),
    },
    {
        path: ':communityName/:faq/:language',
        loadChildren: () => import('./faq/faq-routes').then((m) => m.FAQ_ROUTES),
    },
    { path: '**', redirectTo: '404' },
    { path: '', redirectTo: '404', pathMatch: 'full' },
];
